module.exports = __webpack_public_path__ + "a0f22c0a4e9898391bc773ab4d0611fb.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/traumweltstadt.jpg
// module id = 641
// module chunks = 0